<section [@zoomInOnEnter] class="sessionCard mat-elevation-z2">
	<div class="headerRow">
		<label class="headerLabel">{{ session().title }}</label>
		@if (showActionMenu()) {
			<sim-action-menu (onDelete)="confirmDelete()" [actions]="[{fontIcon: 'fa-edit', click: openEdit(), labelKey: T.BUTTON_EDIT}]" />
		}
	</div>
	<div class="headerRow">
		<span class="secondary">
			<mat-icon fontIcon="fa-clapperboard-play" fontSet="fas" inline />
			{{ session().type | enumLabel: EnumLabel.SessionType }}
		</span>
		<span class="secondary">
			<mat-icon fontIcon="fa-clock" fontSet="far" inline />
			{{ session().startTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }} -
			{{ session().endTime ?? session().plannedEndTime | date: (T.DATE_FORMAT_TIME | translate) :'': translate.currentLang }}
		</span>
		<sim-session-status-tag [status]="session().state" />
	</div>
	<section class="panels">
		@if (runs().length) {
			<div class="panel">
				<sim-session-run-preview [runs]="runs()" />
			</div>
			<div class="panel">
				<sim-session-station-preview [contentTemplate]="contentTemplate" [stations]="session().stations" />
			</div>
		} @else {
			<div class="panel emptyState secondary">
				<mat-icon fontSet="fad" fontIcon="fa-layer-minus" />
				{{ T.PEER_PRACTICE_SESSION_CARD_RUNS_EMPTY_STATE | translate }}
			</div>
		}
	</section>
	<section class="actionsFooter">
		<ng-content select="[actions]" />

		<!--ABORT-->
		@if (canCancelSession()) {
			<button mat-raised-button color="warn" (click)="cancelSession()">
				{{ T.EVENT_SESSION_EXAM_SESSION_ABORT_SESSION_BTN_TXT | translate }}
			</button>
		}
	</section>
</section>

<!--CONTENT TEMPLATE-->
<ng-template #contentTemplate let-context>
	<sim-automatic-recording-session-card-station-content [station]="context.station" />
</ng-template>
